import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './style/Payment.css';
import { API_CONFIG } from './../config'; 
import useUsersData from '../Auth/AllUsers';
import UsePaymentItems from "../Backend/UsePaymentItems";
import TopNavbar from '../home/TopNavbar';

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PAYRAZORPAY}`;

function PayRazorpay() {

    const { id } = useParams();
    const { users } = useUsersData();

    const targetUser = users.find(user => user.id == id);
    const userId = targetUser?.phone;

    // const userId = localStorage.getItem('userPhone') || "";
    const { paymentItems, loading } = UsePaymentItems();

    const [selectedItem, setSelectedItem] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();

    // Find current user details from context/hook
    const matchUser = users?.find(user => String(user.phone) === String(userId));
    const userName = matchUser?.name || "No";
    const userEmail = matchUser?.email || "sarwar123@gmail.com";

    // Save payment details to backend after Razorpay success
    const savePaymentDetails = async (paymentId, itemToBuy) => {
        try {
            const payload = {
                name: userName,
                phone: String(userId),
                email: userEmail,
                amount: itemToBuy?.price || "100",
                buyed: itemToBuy?.type || "all",
                year: String(itemToBuy?.id || "1"),
                paymentId: paymentId,
                coupon: "No",
                date: new Date().toISOString()
            };

            console.log('🔵 Sending Payment Data to API:', CREATE_USER_ENDPOINT);
            console.log('🔵 Payload:', payload);

            const response = await fetch(CREATE_USER_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
                mode: 'cors'
            });

            const responseText = await response.text();
            console.log('🔵 Raw Backend Response:', responseText);

            let data;
            try {
                data = JSON.parse(responseText);
            } catch (parseError) {
                console.error('🔴 Server did not return JSON. Raw output logged above.');
                throw new Error('Server returned non-JSON response.');
            }

            if (!response.ok) {
                throw new Error(data.message || `API failed with HTTP status ${response.status}`);
            }

            console.log('🟢 API Success Response:', data);
            return data;
        } catch (error) {
            console.error('🔴 savePaymentDetails Error:', error.message);
            throw error;
        }
    };

    // Trigger Razorpay Checkout Modal
    const handlePayment = async () => {
        if (!userId) {
            alert('Phone number / User ID is required.');
            return;
        }

        if (!selectedItem) {
            alert('Please select an item first.');
            return;
        }

        setIsProcessing(true);
        const currentAmount = Number(selectedItem.price || 100);

        const options = {
            key: "rzp_test_TVos9I40EBgmwk",
            amount: currentAmount * 100, // Amount in paise
            currency: "INR",
            name: selectedItem.name || "Razorpay",
            description: selectedItem.about || "Subscription payment",
            handler: async function (response) {
                console.log('🟡 Razorpay Gateway Response:', response);

                try {
                    await savePaymentDetails(response.razorpay_payment_id, selectedItem);
                    console.log('🟢 Details saved successfully');
                    localStorage.setItem('userPayment', userId);
                    navigate("/payment-success");
                } catch (error) {
                    console.error('🔴 Payment saved failed due to API error:', error);
                    alert(`Payment successful on Razorpay, but failed to save in Database:\n\n${error.message}`);
                    navigate(`/success?payment_id=${response.razorpay_payment_id}`);
                } finally {
                    setIsProcessing(false);
                }
            },
            prefill: {
                name: userName !== "No" ? userName : "User",
                email: userEmail,
                contact: userId
            },
            notes: {
                address: "My address",
            },
            theme: {
                color: "#000"
            }
        };

        try {
            const pay = new window.Razorpay(options);

            pay.on('payment.failed', function (response) {
                console.error('🔴 Payment failed:', response.error);
                setIsProcessing(false);
                alert(`Payment failed: ${response.error.description}`);
            });

            pay.open();
        } catch (error) {
            console.error('🔴 Error opening payment modal:', error);
            setIsProcessing(false);
            alert('Error initializing payment. Please try again.');
        }
    };

    if (loading) {
        return (
            <div className="product-container">
                <p className="loading-text">Loading premium items...</p>
            </div>
        );
    }

    if (!paymentItems || paymentItems.length === 0) {
        return (
            <div className="product-container">
                <p className="error-text">No payment items available at the moment.</p>
            </div>
        );
    }

    return (
        <div className="product-container">
            <TopNavbar name="Select the item" />
            <h2 className="section-title">Select an Item to Proceed</h2>

            <div className="product-grid">

                <p>Id: {userId}</p>


                {/* Information Card: Email Support */}
                <div className="product-card" style={{ background: "#8affbf" }}>
                    <div className="card-header">
                        <p>If you face any problem or have any query regarding your payment, please email us at:</p>
                        <br />
                        <a href="mailto:payments@mystudyplace.in?subject=NEET%20Prep%20Payment%20Issue" className="email-button">
                            payments@mystudyplace.in
                        </a>
                    </div>
                </div>

                {/* Payment Item Selection List */}
                {paymentItems.slice().reverse().map((item) => {
                    const itemId = item.id;
                    const isSelected = selectedItem?.id === itemId;

                    return (
                        <div
                            key={itemId}
                            className={`product-card ${isSelected ? 'selected' : ''}`}
                            onClick={() => setSelectedItem(item)}
                        >
                            <div className="card-header">
                                <h3>{item.name || "Premium Plan"}</h3>
                            </div>

                            <div className="card-body-row">
                                <p className="price">₹{item.price}</p>
                                <div className="radio-wrapper">
                                    <input
                                        type="radio"
                                        name="product-selection"
                                        checked={isSelected}
                                        onChange={() => setSelectedItem(item)}
                                    />
                                </div>
                            </div>

                            <div className="card-footer">
                                <p className="about">{item.about}.</p>
                                <p className="about">📋 📅 👑 📕 🎴 🧠 ☀️ 🔁 ❔ 🖼️</p>
                                <span className="validity">Validity: {item.valid}</span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Bottom Checkout Section */}
            <div className="payment-checkout-button">
                {userId ? (
                    <>
                        {selectedItem ? (
                            <div className="checkout-section">
                                <button
                                    onClick={handlePayment}
                                    disabled={isProcessing}
                                    className="link checkout-btn"
                                    style={{ width: '100%', cursor: isProcessing ? 'not-allowed' : 'pointer', border: 'none' }}
                                >
                                    <p>
                                        {isProcessing
                                            ? 'Opening Razorpay...'
                                            : <>{selectedItem.name} <strong style={{ color: "orange" }}> ₹{selectedItem.price}</strong> ➔</>}
                                    </p>
                                </button>
                            </div>
                        ) : (
                            <div className="link checkout-btn">
                                <p className="highlight-text">Please select an item.</p>
                            </div>
                        )}
                    </>
                ) : (
                    <Link to="/signup" className="link checkout-btn">
                        <p className="highlight-text">Create account before payment.</p>
                    </Link>
                )}
            </div>
        </div>
    );
}

export default PayRazorpay;